import buttonScComponent from "@/components/child/form/buttonSc.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import { ModalButtonAction } from "@/components/child/modal/modalButtonAction";
import { Component, Prop, Watch } from "@/decorators";
import OrigemProdutoLote from "@/models/enum/origemProdutoLote";
import SituacoesVenda from "@/models/enum/situacoesVenda";
import TipoNotaFiscal from "@/models/enum/tipoNotaFiscal";
import ManipulacaoOrdemModel from "@/models/manipulacaoOrdemModel";
import UsuarioModel from "@/models/usuarioModel";
import VendaItemModel from "@/models/vendaItemModel";
import unidadeMedidaService from "@/services/unidadeMedidaService";
import { AppState, Getters } from "@/store/store";
import Delay from "@/utils/common/delay";
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import ManipulacaoEditComponent from "../manipulacao/edit";
import manipulacaoEditComponent from "../manipulacao/edit.vue";
import ManipulacaoNewComponent from "../manipulacaoNew/edit";
import manipulacaoNewComponent from "../manipulacaoNew/edit.vue";
import ShortcutComponent from "../shortcut/shortcut";
import shortcutComponent from "../shortcut/shortcut.vue";
import AcabadoForm from "./acabadoForm";
import acabadoForm from "./acabadoForm.vue";
import "./itemWrapper.scss";
import VendaEstoqueComponent from "./vendaEstoque";
import vendaEstoqueComponent from "./vendaEstoque.vue";

@Component({
    components: {
        manipulacaoEditComponent,
        manipulacaoNewComponent,
        acabadoForm,
        buttonScComponent,
        comboComponent,
        checkboxComponent,
        fieldsetComponent,
        shortcutComponent,
        vendaEstoqueComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
        ...mapGetters([
            "HAS_PERMISSAO_PERFIL",
            "GET_IS_FRACIONAMENTO",
            "GET_IS_ESTEREIS",
            "VALIDAR_PERMISSAO_SOMENTE_CONSULTA",
        ] as Getters),
    },
})
export default class ItemWrapperComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;
    GET_IS_FRACIONAMENTO: () => Promise<boolean>;
    GET_IS_ESTEREIS: () => Promise<boolean>;
    HAS_PERMISSAO_PERFIL: (isRede: boolean, isFranqueador: boolean, isSuporte: boolean) => Promise<boolean>;
    VALIDAR_PERMISSAO_SOMENTE_CONSULTA: (telaDescricao: string) => boolean;

    private shortcutComponent: ShortcutComponent = null;

    public manipulacaoEditComponent: ManipulacaoEditComponent = null;
    public manipulacaoNewComponent: ManipulacaoNewComponent = null;
    private acabadoForm: AcabadoForm | null = null;
    private vendaEstoqueComponent: VendaEstoqueComponent = null;

    private somenteConsultaVenda = false;
    private isManipulacao = false;
    private isAcabado = false;
    private isVendaEstoque = false;

    isFracionamento = false;
    isEstereis = false;
    isAdmin = false;
    isAdminRede = false;
    desativaCampos = false;
    classSC = "manipulacaoShortCut-modal";

    isManipulacaoNew = false;

    @Prop({ type: Array, default: () => [] }) itensVenda;
    @Prop({ type: Number, default: 0 }) situacaoVenda: number;
    @Prop({ type: Boolean, default: false }) utilizaValorCusto: boolean;
    @Prop({ type: Number, default: 0 }) indexVenda: number;
    @Prop({ type: Boolean, default: false }) isActiveTab: boolean;
    @Prop({ type: Boolean, default: false }) vendaFaturada: boolean;
    @Prop({ type: Boolean, default: false }) vendaReplicada: boolean;
    @Prop(Number) pacienteId: number;
    @Prop(Number) clienteId: number;
    @Prop(Number) estoqueId: number;
    @Prop(Number) setorId: number;
    @Prop(String) nomeVendedor: string;
    @Prop({ type: Boolean, default: false, required: false }) isSituacaoPreVenda: boolean;

    @Prop(Function) tipoNFOptionsCallback;

    private tipoNFOptions: Array<object> = [];

    total = 0;

    private extraButtonAction: Array<ModalButtonAction> = [];

    private model: VendaItemModel = new VendaItemModel();
    private editingModel = false;
    private uplodingModel = false;

    private emitirEventoAdicionar() {
        if (this.editingModel) {
            this.$emit("edicao-item", this.getModel());
        } else {
            this.$emit("inclusao-item", this.getModel(), this.indexVenda);
        }
    }

    private async onManipulacaoInsert(model: ManipulacaoOrdemModel, vendaItem: VendaItemModel) {
        this.model.tipoNF = vendaItem.tipoNF;
        this.model.movimentaEstoque = vendaItem.movimentaEstoque;
        this.model.estoqueId = vendaItem.estoqueId;
        this.model.continuo = vendaItem.continuo;
        this.model.dataVencimentoContinuo = vendaItem.dataVencimentoContinuo;

        this.model.manipulacaoOrdem = model;
        if (model.formulaPadraoId != 0 && model.formulaPadraoId != null) {
            this.model.produtoDescricao = model.formulaPadraoDescricao;
        } else {
            const unidadeMedidaCombo = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId);
            const unidadeMedida =
                unidadeMedidaCombo.find(p => p.value == model.itens[0].unidadeMedidaManipulacaoId)?.text ?? "";

            const itemPrincipal = model.itens.some(p => p.ativoPrincipal)
                ? model.itens.find(p => p.ativoPrincipal)
                : model.itens[0];

            this.model.produtoDescricao = `Manipulação ${model.formaFarmaceuticaDescricao} Ativo (${
                itemPrincipal.sinonimo ? itemPrincipal.sinonimo.sinonimo : itemPrincipal.produtoDescricao
            } - ${itemPrincipal.quantidadeDose} ${unidadeMedida})`;
        }

        this.model.quantidade = model.numeroFormulas;
        this.model.valorTotal = model.valorTotal;
        this.model.valorUnitario = model.valorTotal;
        this.model.acrescimo = model.acrescimo;
        this.model.desconto = model.desconto;
        this.model.dataValidade = model.dataValidade;

        this.shortcutComponent.hide();
        this.emitirEventoAdicionar();
    }

    private async onVendaItemInsert(model: VendaItemModel) {
        this.shortcutComponent.hide();

        if (this.isVendaEstoque) {
            await this.setupItemFracionamento(model);
        }

        this.model.updateFrom(model);
        this.emitirEventoAdicionar();
    }

    private async onVendaItemEdit(model: VendaItemModel) {
        this.shortcutComponent.hide();

        if (this.isVendaEstoque) {
            await this.setupItemFracionamento(model);
        }

        this.model.updateFrom(model, ["tipoNF"]);
        this.emitirEventoAdicionar();
    }

    private async setupItemFracionamento(model: VendaItemModel) {
        if (model.fracionamento?.itens[0]?.produtoLote?.origemProdutoLote == OrigemProdutoLote.Fracionamento) {
            const produtoLote = model.fracionamento?.itens[0]?.produtoLote;
            const volumeFracionado = produtoLote.volumeFracionado.toFixed(2).replace(".", ",");
            model.produtoDescricao = `${model.produtoDescricao} ${volumeFracionado} ${produtoLote.unidadeMedidaFracionadoSigla}`;
        }

        const itensVenda = [...this.itensVenda] as VendaItemModel[];
        itensVenda.push(model);
        const itensMesmoProduto = itensVenda.filter(
            p =>
                p.fracionamento != null &&
                p.fracionamento.itens[0].produtoId == model.produtoId &&
                p.fracionamento.itens[0].produtoLote.origemProdutoLote == OrigemProdutoLote.Fracionamento,
        );

        if (itensMesmoProduto.length > 1) {
            const quantidadeTotal = itensMesmoProduto.reduce(
                (acc, p) =>
                    acc +
                    Number(p.fracionamento.itens[0].quantidade) * p.fracionamento.itens[0].produtoLote.volumeFracionado,
                0,
            );

            const markup = model.fracionamento.itens[0].getMarkupByQuantidade(quantidadeTotal);
            const itensComMarkupDiferente = itensMesmoProduto.filter(
                p => markup && p.fracionamento.markupItemVenda != markup,
            );

            if (itensComMarkupDiferente.length > 0) {
                await this.$showWarning(
                    "Alteração Markup Dinâmico",
                    `Devido a alteração das quantidades os valores dos itens cujo produto seja ${model.fracionamento.itens[0].produto.descricao} serão recalculados aplicando o markup dinâmico`,
                );
            }

            itensComMarkupDiferente.forEach(p => {
                p.fracionamento.markupItemVenda = markup;
                p.fracionamento.itens[0] = p.fracionamento.calcularValorTotal(p.fracionamento.itens[0]);
                p.valorTotal = p.fracionamento.valorTotal;
            });

            this.$emit("onUpdateItensFracionamento", itensComMarkupDiferente);
        }
    }

    //@ts-ignore
    @Watch("editingModel")
    private onChangeEditingModel() {
        this.loadExtraButtons();
    }

    private onDesativaCampos(campos: boolean) {
        this.desativaCampos = campos;
        this.loadExtraButtons();
    }

    private loadExtraButtons() {
        this.extraButtonAction = [];
        if (!this.desativaCampos) {
            this.extraButtonAction.push(
                new ModalButtonAction(
                    this.editingModel ? "Alterar" : "Adicionar",
                    this.editingModel ? "Alterar" : "Adicionar",
                    true,
                    "a",
                    "btn btn-primary",
                ),
            );
        }
    }

    private onAdicionarManipulacao(model: ManipulacaoOrdemModel) {
        this.model.manipulacaoOrdem = model;

        this.model.quantidade = model.numeroFormulas;
        this.model.valorTotal = model.valorTotal;
        this.model.valorUnitario = model.valorTotal;

        this.emitirEventoAdicionar();
    }

    private updateNFOptions() {
        this.tipoNFOptions = this.tipoNFOptionsCallback(this.model);
    }

    public clear() {
        this.model = new VendaItemModel();
    }

    public getModel() {
        const model = new VendaItemModel();
        model.updateFrom(this.model);
        return model;
    }

    private onAtualizaTotalItemManipulacao(total: number, atualizar = false) {
        this.total = total;
        if (atualizar && total > 0) {
            if (this.isManipulacaoNew) {
                this.manipulacaoNewComponent.loadManipulacaoContext();
                this.model.manipulacaoOrdem.updateFrom(this.manipulacaoNewComponent.manipulacao);
            } else {
                this.manipulacaoEditComponent.loadManipulacaoContext();
                this.model.manipulacaoOrdem.updateFrom(this.manipulacaoEditComponent.manipulacao);
            }
            this.model.valorTotal = +this.model.manipulacaoOrdem.valorTotal.toFixed(2);
            this.model.valorUnitario = +this.model.valorTotal.toFixed(2);
        }
    }

    private onAtualizaTotalItemProduto(total: number) {
        this.total = total;
    }

    @Watch("isManipulacao")
    private onIsManipulacaoChanged(newValue: boolean) {
        if (newValue) {
            this.setIsManipulacao();
            this.classSC = "manipulacaoShortCut-modal";
        }
    }

    @Watch("isVendaItem")
    private onIsVendaItemChanged(newValue) {
        if (newValue) {
            this.model.manipulacaoOrdem = null;
            this.setIsVendaItem();
            this.classSC = "lg-modal";
        }
    }

    private async onLoadPreVenda(model: ManipulacaoOrdemModel) {
        if (this.isManipulacaoNew) {
            await this.manipulacaoNewComponent.clear();
        } else {
            await this.manipulacaoEditComponent.clear();
        }

        const vendaItem = new VendaItemModel();
        vendaItem.tipoNF = TipoNotaFiscal.Servico;
        vendaItem.manipulacaoOrdem = model;

        await this.load(vendaItem, true);

        if (this.isManipulacaoNew) {
            await this.manipulacaoNewComponent.consolidarPreVenda();
        } else {
            await this.manipulacaoEditComponent.consolidarPreVenda();
        }
    }

    private validarPermissaoBotaoVenda(botao: string): boolean {
        if (this.somenteConsultaVenda) {
            return false;
        }

        const isPreVendaOuPrefaturamento =
            this.situacaoVenda == SituacoesVenda.PreRecebimento || this.situacaoVenda == SituacoesVenda.PreVenda;

        const situacaoIncorreta =
            this.situacaoVenda > SituacoesVenda.Faturado && this.situacaoVenda != SituacoesVenda.Fracionando;

        if (botao === "manipulacao" || botao === "homeopatia") {
            return (
                ((!situacaoIncorreta && !this.isFracionamento) || this.isAdmin || this.isAdminRede) &&
                !isPreVendaOuPrefaturamento
            );
        } else if (botao === "acabado") {
            return (!situacaoIncorreta || this.isAdmin || this.isAdminRede) && !isPreVendaOuPrefaturamento;
        } else if (botao === "fracionamento") {
            return !situacaoIncorreta && this.isFracionamento && !isPreVendaOuPrefaturamento;
        } else if (botao === "preVenda") {
            return isPreVendaOuPrefaturamento;
        }
    }

    @Watch("isVendaEstoque")
    private onIsVendaItemEstoqueChanged(newValue) {
        if (newValue) {
            this.model.manipulacaoOrdem = null;
            this.setIsVendaEstoque();
            this.classSC = "fracionamentoShortCut-modal";
        }
    }

    // TODO: gambiarra temporária, mas precisamos refatorar o itemwrapper para não ficar criando instâncias de item
    // O Cláudio disse que o bug tem haver com o onChangeMovimentaEstoque
    @Watch("model.movimentaEstoque")
    private onMovimentaEstoqueChanged(newVal: boolean) {
        if (this.isAcabado && !this.isEstereis && !this.model.id && this.acabadoForm) {
            this.acabadoForm.model.movimentaEstoque = newVal;
        }
    }

    public async load(item: VendaItemModel, isPreVenda = false, isShowModal = true) {
        this.total = 0;
        this.uplodingModel = true;

        if (item.manipulacaoOrdem == null) {
            if (item.vendaEstoque) {
                this.setIsVendaEstoque();
                await this.loadVendaEstoqueComponent().withLoading();

                this.vendaEstoqueComponent.clear(false);
                this.model = new VendaItemModel();
                this.model.updateFrom(item);
                this.total = this.model.valorTotal;
                this.editingModel = true;
                this.shortcutComponent.show();
                await this.vendaEstoqueComponent.loadModel(this.model);
            } else {
                this.setIsVendaItem();
                await this.loadAcabadoForm().withLoading();

                this.acabadoForm!.setPreLoad();
                this.acabadoForm!.clear();
                this.model.updateFrom(item);
                this.total = this.model.valorTotal;
                this.editingModel = true;
                if (isShowModal) {
                    this.shortcutComponent.show();
                    this.acabadoForm!.loadModel(this.model);
                }
            }
        } else {
            this.setIsManipulacao();
            await this.loadManipulacaoEditComponent();

            if (this.isManipulacaoNew) {
                await this.manipulacaoNewComponent.clear();
            } else {
                await this.manipulacaoEditComponent.clear();
            }
            this.model.manipulacaoOrdem = new ManipulacaoOrdemModel();
            this.model.updateFrom(item, ["manipulacaoOrdem"]);
            this.model.manipulacaoOrdem.updateFrom(item.manipulacaoOrdem);
            this.total = this.model.manipulacaoOrdem.valorTotal;
            ///volta do item venda para manipulacoa, para manter iguais
            this.model.manipulacaoOrdem.acrescimo = this.model.acrescimo;
            this.model.manipulacaoOrdem.desconto = this.model.desconto;

            if (isShowModal) {
                if (this.isManipulacaoNew) {
                    await this.manipulacaoNewComponent
                        .loadModel(this.model.manipulacaoOrdem, this.model, isPreVenda)
                        .withLoading();
                } else {
                    await this.manipulacaoEditComponent
                        .loadModel(this.model.manipulacaoOrdem, this.model, isPreVenda)
                        .withLoading();
                }
                this.uplodingModel = false;
                this.editingModel = !isPreVenda;
                this.shortcutComponent.show();
            } else {
                this.uplodingModel = false;
                this.editingModel = !isPreVenda;
            }
        }

        this.updateNFOptions();

        if (this.isManipulacao) {
            if (this.isManipulacaoNew) {
                this.manipulacaoNewComponent.loadManipulacaoContext();
            } else {
                this.manipulacaoEditComponent.loadManipulacaoContext();
            }
        }
    }

    private async onCancelar() {
        if (this.isManipulacao) {
            if (this.isManipulacaoNew) {
                await this.manipulacaoNewComponent.clear();
                this.manipulacaoNewComponent.unsubscribeAll();
            } else {
                await this.manipulacaoEditComponent.clear();
                this.manipulacaoEditComponent.unsubscribeAll();
            }
        }
    }

    private async onManipulacao(isHomeopatia = false) {
        this.setIsManipulacao();
        await this.loadManipulacaoEditComponent();

        let titulo = "";

        if (!isHomeopatia) {
            titulo = this.$t("__.Components.parent.venda.itemwrapper_vue_html.manipulacao") as string;
        } else {
            if (this.isSituacaoPreVenda) {
                titulo = this.$t("__.Components.parent.venda.itemwrapper_vue_html.preVenda") as string;
            } else {
                this.$t("__.Components.parent.venda.itemwrapper_vue_html.homeopatia") as string;
            }
        }

        this.total = 0;
        this.shortcutComponent.title = titulo;
        this.editingModel = false;
        this.model = new VendaItemModel();
        this.model.tipoNF = TipoNotaFiscal.Servico;
        this.model.manipulacaoOrdem = new ManipulacaoOrdemModel();
        this.updateNFOptions();

        if (this.isManipulacaoNew) {
            this.manipulacaoNewComponent.isHomeopatia = isHomeopatia;
            //quando for pelo botao, limpar sempre
            await this.manipulacaoNewComponent.clear(true);
            this.manipulacaoNewComponent.setPacientePrescritor();
        } else {
            this.manipulacaoEditComponent.isHomeopatia = isHomeopatia;
            //quando for pelo botao, limpar sempre
            await this.manipulacaoEditComponent.clear(true);
            this.manipulacaoEditComponent.setPacientePrescritor();
        }

        this.shortcutComponent.show();
    }

    private async onPreVenda() {}

    private async onProduto() {
        this.setIsVendaItem();
        await this.loadAcabadoForm();
        this.acabadoForm!.setPreLoad();

        this.total = 0;
        this.shortcutComponent.title = "Produto";
        this.editingModel = false;
        this.model = null;
        this.model = new VendaItemModel();
        if (!this.isEstereis && this.isAcabado) {
            this.model.tipoNF = TipoNotaFiscal.CupomFiscal;
        }
        this.model.manipulacaoOrdem = null;
        this.model.manipulacaoOrdemId = null;
        this.updateNFOptions();
        this.acabadoForm!.clear(true);
        this.shortcutComponent.show();
    }

    private async onFracionar() {
        this.setIsVendaEstoque();
        await this.loadVendaEstoqueComponent();

        this.total = 0;
        this.shortcutComponent.title = "Fracionamento de Estoque";
        this.editingModel = false;
        this.model = null;
        this.model = new VendaItemModel();
        this.model.tipoNF = TipoNotaFiscal.DANFe;
        this.model.vendaEstoque = true;
        this.model.manipulacaoOrdem = null;
        this.model.manipulacaoOrdemId = null;
        this.updateNFOptions();
        this.vendaEstoqueComponent.clear();
        this.shortcutComponent.show();
    }

    private async onConfirm() {
        if (this.isManipulacao) {
            if (this.isManipulacaoNew) {
                if (await this.manipulacaoNewComponent.onAdicionarManipulacao()) {
                    this.shortcutComponent.hide();
                }
            } else {
                if (await this.manipulacaoEditComponent.onAdicionarManipulacao()) {
                    this.shortcutComponent.hide();
                }
            }
        } else if (this.isAcabado) {
            if (await this.acabadoForm!.onAdicionarItem()) {
                this.shortcutComponent.hide();
            }
        } else if (this.isVendaEstoque) {
            if (!this.model.id) {
                this.vendaEstoqueComponent.modelFracionamento.tipoNF = this.model.tipoNF;
                this.vendaEstoqueComponent.modelFracionamento.movimentaEstoque = this.model.movimentaEstoque;
            }
            if (await this.vendaEstoqueComponent.onAdicionarItemEstoque()) {
                this.shortcutComponent.hide();
            }
        }
    }

    // botão para limpar os campos
    private async onExtraButtonActionClick(name: string) {
        if (name == "Adicionar" || name == "Alterar") {
            this.onConfirm();
        }
    }

    public inFocus() {
        return !this.shortcutComponent.isShowing();
    }

    private async onManipulacaoMounted() {
        await this.loadManipulacaoEditComponent();
    }

    private onChangeMovimentaEstoque(movimentaEstoque: boolean) {
        this.model.movimentaEstoque = movimentaEstoque;
    }

    private setIsManipulacao() {
        this.isManipulacao = true;
        this.isAcabado = false;
        this.isVendaEstoque = false;
    }

    private setIsVendaItem() {
        this.isManipulacao = false;
        this.isAcabado = true;
        this.isVendaEstoque = false;
    }

    private setIsVendaEstoque() {
        this.isManipulacao = false;
        this.isAcabado = false;
        this.isVendaEstoque = true;
    }

    private async loadManipulacaoEditComponent() {
        if (this.isManipulacaoNew) {
            while (!this.$refs.manipulacaoNewComponent) await Delay(5);
            this.manipulacaoNewComponent = this.$refs.manipulacaoNewComponent as ManipulacaoNewComponent;
        } else {
            while (!this.$refs.manipulacaoEditComponent) await Delay(5);
            this.manipulacaoEditComponent = this.$refs.manipulacaoEditComponent as ManipulacaoEditComponent;
        }
    }

    private async loadAcabadoForm() {
        while (!this.$refs.acabadoForm) await Delay(5);
        this.acabadoForm = this.$refs.acabadoForm as AcabadoForm;
    }

    private async loadVendaEstoqueComponent() {
        while (!this.$refs.vendaEstoqueComponent) await Delay(5);
        this.vendaEstoqueComponent = this.$refs.vendaEstoqueComponent as VendaEstoqueComponent;
    }

    private async mounted() {
        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
        this.manipulacaoEditComponent = this.$refs.manipulacaoEditComponent as ManipulacaoEditComponent;
        this.manipulacaoNewComponent = this.$refs.manipulacaoNewComponent as ManipulacaoNewComponent;
        this.acabadoForm = this.$refs.acabadoForm as AcabadoForm;
        this.vendaEstoqueComponent = this.$refs.vendaEstoqueComponent as VendaEstoqueComponent;

        this.isFracionamento = await this.GET_IS_FRACIONAMENTO();
        this.isAdminRede = await this.HAS_PERMISSAO_PERFIL(true, false, false);
        this.isAdmin = await this.HAS_PERMISSAO_PERFIL(false, false, false);
        this.isEstereis = await this.$store.getters.GET_IS_ESTEREIS();

        this.loadExtraButtons();

        this.isSituacaoPreVenda =
            this.situacaoVenda == SituacoesVenda.PreVenda || this.situacaoVenda == SituacoesVenda.PreRecebimento;

        // this.isManipulacaoNew = this.usuarioLogado.franquiaId == 93;

        this.somenteConsultaVenda = this.VALIDAR_PERMISSAO_SOMENTE_CONSULTA("vendas");
    }
}
